import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { HTTPService } from "../Services/http.service";
import { DatePipe } from "@angular/common";
import { Constants } from "../Services/Constants";
import { MySharedService } from "../App/shared.service";
import { Cookie } from "ng2-cookies/ng2-cookies";

@Component({
  selector: "headerTemplate",
  templateUrl: "../AppViews/Common/Header.html",
})
export class TopheaderLayoutComponent implements OnInit {
  constant: Constants;
  isNotSubmittedTimesheet: boolean = false;
  configData: any = [];
  public showLoader = false;

  //called first time before the ngOnInit()
  constructor(
    private _httpService: HTTPService,
    private _router: Router,
    private _DatePipe: DatePipe,
    private _sharedService: MySharedService,
  ) {
    this.constant = new Constants();
    this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
    if (this.userDetail == null || typeof this.userDetail == "undefined") {
      this._router.navigate(["login"]);
    }

    var minute = this.constant.SessionTimeOut; // Reset when storage is more than 24hours
    var now = moment().valueOf().toString();
    var setupTime = localStorage.getItem("setupTime");
    if (setupTime == null || typeof setupTime == "undefined") {
      localStorage.setItem("setupTime", now);
    } else {
      if (parseInt(now) - parseInt(setupTime) > minute * 60 * 1000) {
        localStorage.clear();
        this._sharedService.ShowMessage("error|Session Expired..");
        this._router.navigate(["login"]);
      }
    }
  }

  ngAfterViewInit() {
    $("#menu-toggle").click(function () {
      $(this).hasClass("open")
        ? ($(this).removeClass("open"),
          $(".left-menu").css("left", "-100%"),
          setTimeout(function () {
            $(".left-menu").css("display", "none");
          }, 500))
        : ($(this).addClass("open"),
          $(".left-menu").css("display", "block"),
          setTimeout(function () {
            $(".left-menu").css("left", "0");
          }, 100));
    });
  }
  userDetail: any;

  ngOnInit() {
    $("#notification-popup").popover({
      html: !0,
      content:
        '<p class="notification-data">Fill up your previous day timesheet <a href="javascript:void(0)" id="close_notification"><i class="fa fa-times"></i></a></p>',
    });
    var timesheetInfo = localStorage.getItem("isNotSubmittedTimesheet");
    if (timesheetInfo == null) {
      if (this.userDetail.RoleId != 4) {
        this.checkTimesheetSubmitted();
      }
    } else {
      this.isNotSubmittedTimesheet = timesheetInfo == "1" ? true : false;
    }
  }

  public logOut() {
    localStorage.clear();
    this._router.navigate(["login"]);
  }


  public logOutCDB() {
    localStorage.clear();

    let centralLogin = false;
    const cookieValue = JSON.parse(Cookie.get("centralLogin")) || false;
    if (this._httpService.isCentralLogin && cookieValue) {
      centralLogin = cookieValue == true;
    }
    if (centralLogin) {
      if (typeof window !== "undefined") {
        window.location.href = this._httpService.centralBaseUrl;
        return;
      }
    }
    this._router.navigate(["/login"]);
  }

  public checkTimesheetSubmitted() {
    this._httpService
      .ajaxPost("Timesheet/GetTimesheet", {
        TimesheetId: 0,
        UserId: this.userDetail.SiteUserId,
        ProjectId: "",
        FromDate: moment().subtract(1, "days").format("DD/MM/YYYY"),
        ToDate: moment().subtract(1, "days").format("DD/MM/YYYY"),
        TaskTypeId: 0,
        TaskGroupId: 0,
        TeamId: this.userDetail.TeamID,
        LoggedInUser: this.userDetail.SiteUserId,
      })
      .subscribe(
        (data) => {
          if (data["TimesheetList"].length > 0) {
            this.isNotSubmittedTimesheet = false;
            localStorage.setItem("isNotSubmittedTimesheet", "0");
          } else {
            this.isNotSubmittedTimesheet = true;
            localStorage.setItem("isNotSubmittedTimesheet", "1");
          }
        },
        (err) => {
          console.log("GetTimesheetList Failed");
        },
      );
  }
  goToLink() {
    this._httpService
      .ajaxPost("Common/GetHRMSToken", {
        ProfileId: this.userDetail.SiteUserId,
      })
      .subscribe(
        (data) => {
          var url =
            this._httpService.HRMSUrl + encodeURIComponent(data["HRMSToken"]);
          window.open(url, "_blank");
        },
        (err) => {
          console.log("GetTimesheetList Failed");
        },
      );
  }

  GetConfigData() {
    this._httpService.ajaxPost("Common/GetConfigData").subscribe(
      (data) => {
        this.configData = data;
        $("#configModal").modal("show");
      },
      (err) => {
        console.log("GetCityData Failed with status: " + err.status);

        this.showLoader = false;
        this._sharedService.ShowMessage(this.constant.globalError);
      },
      () => {
        this.showLoader = false;
      },
    );
    setTimeout(function () {
      $(".pop-comment").popover({
        //content: 'test'
        content: function () {
          return $(this).parent().find("p").html();
        },
      });
    }, 500);
  }
}



/** WEBPACK FOOTER **
 ** ./TypeScripts/Layout/topHeaderLayout.component.ts
 **/